import { useQuery } from "@tanstack/react-query";
import { instance2 } from "src/components/utils/axiosInstance";

const queryFn = async () => {
  const res = await instance2.get("/customers/clusters");
  return res.data;
};

export const useGetClusters = () =>
  useQuery({ queryKey: ["clusters"], queryFn });
